import React from "react";
import PropTypes from "prop-types";
import { useTracker } from "./useTracker";

const Trackable = ({
  loadId,
  interfaceId,
  context,
  modal,
  children
}) => {
  const tracker = useTracker();
  React.useEffect(() => {
    const prevInterfaceId = tracker.getInterfaceId();

    if (interfaceId) {
      tracker.setInterfaceId(interfaceId);
    }

    if (context) {
      tracker.setLocalContext(context);
    }

    tracker.logEvent(loadId);
    return () => {
      if (modal) {
        tracker.setInterfaceId(prevInterfaceId);
      }

      tracker.setLocalContext(null);
    };
  }, []);
  return children;
};

Trackable.defaultProps = {
  modal: false
};
Trackable.propTypes = {
  loadId: PropTypes.string.isRequired,
  interfaceId: PropTypes.string,
  context: PropTypes.object,
  modal: PropTypes.bool,
  children: PropTypes.node.isRequired
};
export default Trackable;